import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },

  title: {
    fontSize: theme.spacing(6),
    textTransform: 'uppercase',
    textAlign: 'center',
    fontWeight: 'bold',
  },

  button: {
    textTransform: 'uppercase',
  },
}));
